/* eslint-disable jsx-a11y/anchor-is-valid */
import Modal from "react-modal";
import { Button, ErrorAlert, SuccessAlert } from "../common/Forms";
import Icon from "../common/Icon";
import { useState } from "react";
import { CSVLink } from "react-csv";
import { toCSV } from "react-csv/lib/core";

const UploadModal = ({
  isOpen,
  loading,
  result,
  message,
  error,
  userFile,
  lectureList,
  lecture,
  type,
  onClose,
  onFile,
  onUpload,
  onSelect,
  onType,
}) => {
  const CSV_HEADER = ["이름", "휴대전화", "성별", "학교", "나이"];
  const SCHOOL_GR = [
    { name: "7", label: "초등학교" },
    { name: "13", label: "중학교" },
    { name: "16", label: "고등학교" },
  ];
  const [data, setData] = useState({
    name: "",
    tel: "",
    gender: "",
    school: "",
    school_gr: "",
    age: "",
  });
  const [list, setList] = useState([]);

  const handleTabClick = (v) => (e) => {
    if (data[v] === e.target.name) {
      setData({ ...data, [v]: "" });
    } else {
      setData({ ...data, [v]: e.target.name });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleAddClick = () => {
    if (data.name) {
      const { school: schl_nm, school_gr, ...rest } = data;
      let school = "";
      const [gr] = SCHOOL_GR.filter(({ name }) => name === school_gr);
      if (schl_nm && gr) {
        school = `${schl_nm}${gr.label}`;
      }
      setList([...list, { ...rest, school }]);
      setData({
        name: "",
        tel: "",
        gender: "",
        school: "",
        school_gr: "",
        age: "",
      });
    }
  };
  const handleUpload = () => {
    const csvContent = toCSV(
      list,
      [
        { label: "이름", key: "name" },
        { label: "휴대전화", key: "tel" },
        { label: "성별", key: "gender" },
        { label: "학교", key: "school" },
        { label: "나이", key: "age" },
      ],
      ",",
      ``
    );
    const blob = new Blob(["\ufeff" + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    onUpload(blob);
  };
  const deleteOnList = (i) => () => {
    list.splice(i, 1);
    setList([...list]);
  };

  const handleClose = () => {
    setData({
      name: "",
      tel: "",
      gender: "",
      school: "",
      school_gr: "",
      age: "",
    });
    setList([]);
    onClose();
  };

  return (
    <Modal
      ariaHideApp={false}
      className="flex h-full text-center"
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <div className="w-full p-4 m-auto bg-white card md:w-5/12 md:shadow-xl">
        <div className="w-full gap-2 overflow-hidden card-body">
          <div className="justify-center gap-2 mb-2 bg-transparent tabs tabs-boxed">
            {[
              { type: "imweb", label: "아임웹 회원 업로드" },
              { type: "csv", label: "csv 파일 업로드" },
              { type: "direct", label: "직접 입력" },
            ].map((item) => (
              <a
                key={item.type}
                name={item.type}
                className={`tab ${type === item.type ? "tab-active" : ""}`}
                onClick={onType}
              >
                {item.label}
              </a>
            ))}
          </div>
          <div className="inline-flex flex-shrink w-full h-12 pr-4 overflow-hidden text-sm leading-loose border select-box border-accent bg-base-100 rounded-btn">
            <label
              htmlFor="upload_lecture"
              className="border-accent bg-accent text-accent-content font-bold inline-flex flex-shrink-0 select-none flex-wrap items-center justify-center text-center transition duration-200 ease-out h-[2.875rem] px-[17px] text-sm min-h-[2.875rem] mr-4 shadow-[inset_-1px_-1px_rgba(0,0,0,0.3)]"
            >
              강의 선택
            </label>
            <select
              id="upload_lecture"
              className="w-full bg-transparent outline-none"
              onChange={onSelect}
              disabled={loading || (!error && result)}
            >
              {lectureList.map(({ _id: id, title: v }) => (
                <option
                  key={`option_${v}`}
                  value={id}
                  selected={lecture === id}
                >
                  {v}
                </option>
              ))}
            </select>
          </div>
          {type === "imweb" && (
            <div className="flex flex-col w-full gap-2">
              <input
                type="file"
                name="excel_upload"
                accept=".xls,.xlsx"
                className="w-full text-sm file-input file-input-bordered file-input-accent"
                onChange={onFile}
                disabled={loading || (!error && result)}
              />
              {result !== true && (
                <Button
                  type="primary"
                  size="sm"
                  onClick={onUpload}
                  disabled={!userFile || loading || (!error && result)}
                >
                  업로드
                </Button>
              )}
            </div>
          )}
          {type === "csv" && (
            <div className="flex flex-col w-full gap-2">
              <input
                type="file"
                name="csv_upload"
                accept=".csv"
                className="w-full text-sm file-input file-input-bordered file-input-accent"
                onChange={onFile}
                disabled={loading || (!error && result)}
              />
              {result !== true && (
                <div className="flex items-center w-full gap-2">
                  <CSVLink
                    data={[CSV_HEADER]}
                    enclosingCharacter={``}
                    separator={","}
                    filename={"form_themaker.csv"}
                    className="btn btn-info btn-outline btn-sm"
                    target="_blank"
                  >
                    양식 다운로드
                  </CSVLink>
                  <span className="text-xs">
                    * 양식을 다운로드 받아 회원정보를 입력하고 업로드하세요.
                  </span>
                </div>
              )}
              {result !== true && (
                <Button
                  type="primary"
                  size="sm"
                  onClick={onUpload}
                  disabled={!userFile || loading || (!error && result)}
                >
                  업로드
                </Button>
              )}
            </div>
          )}
          {type === "direct" && (
            <div className="flex flex-col w-full gap-y-2 gap-x-4">
              <div className="flex flex-row flex-wrap justify-between gap-2 p-4 border rounded-lg form-control ">
                {list.length > 0 && (
                  <div className="w-full mb-2 overflow-auto max-h-60">
                    <table className="table w-full table-compact">
                      <thead>
                        <tr>
                          <th></th>
                          <th>No.</th>
                          {CSV_HEADER.map((v) => (
                            <th>{v}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((item, i) => (
                          <tr>
                            <th>
                              <button
                                className="btn btn-circle btn-outline btn-xs"
                                onClick={deleteOnList(i)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-4 h-4"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                  />
                                </svg>
                              </button>
                            </th>
                            <th>{i + 1}</th>
                            <td>{item.name}</td>
                            <td>{item.tel}</td>
                            <td>{item.gender}</td>
                            <td>{item.school}</td>
                            <td>{item.age}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {[
                  {
                    name: "name",
                    type: "text",
                    label: "이름*",
                    required: true,
                    value: data.name,
                  },
                  {
                    name: "tel",
                    type: "tel",
                    label: "휴대전화",
                    required: false,
                    value: data.tel,
                  },
                  // {
                  //   name: "user_id",
                  //   type: "text",
                  //   label: "아이디",
                  //   required: false,
                  //   value: data.user_id,
                  // },
                  // {
                  //   name: "password",
                  //   type: "text",
                  //   label: "비밀번호",
                  //   required: false,
                  //   value: data.password,
                  // },
                  {
                    name: "gender",
                    type: "tabs",
                    label: "성별",
                    required: false,
                    list: [
                      { name: "M", label: "남" },
                      { name: "F", label: "여" },
                    ],
                  },
                  // {
                  //  name: "memo",
                  //  type: "text",
                  //  label: "메모",
                  //  required: false,
                  //  value: data.memo,
                  // },
                  {
                    name: "school",
                    type: "text",
                    label: "학교명",
                    required: false,
                    value: data.school,
                  },
                  {
                    name: "school_gr",
                    type: "tabs",
                    label: "학교",
                    required: false,
                    list: SCHOOL_GR,
                  },
                  {
                    name: "age",
                    type: "tabs",
                    label: "학년",
                    required: false,
                    list: new Array(Number(data.school_gr) > 7 ? 3 : 6)
                      .fill(null)
                      .map((_, i) => ({
                        name: (Number(data.school_gr) + i).toString(),
                        label: `${i + 1}학년`,
                      })),
                  },
                ].map((item) => (
                  <div className="flex flex-row min-w-[49%] gap-1">
                    <label className="justify-end w-12 p-1 label">
                      <span className="text-xs label-text">{item.label}</span>
                    </label>
                    {["text", "tel"].includes(item.type) && (
                      <input
                        name={item.name}
                        type={item.type}
                        placeholder={item.label}
                        className="flex-1 input input-bordered input-sm"
                        required={item.required}
                        onChange={handleInputChange}
                        value={item.value}
                      />
                    )}
                    {item.type === "tabs" && (
                      <div className="flex-1 p-0 bg-transparent tabs tabs-boxed">
                        {item.list.map((tab) => (
                          <button
                            name={tab.name}
                            className={`tab${
                              tab.name === data[item.name] ? " tab-active" : ""
                            }`}
                            onClick={handleTabClick(item.name)}
                          >
                            {tab.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
                <Button
                  type="accent"
                  size="sm"
                  onClick={handleAddClick}
                  disabled={!data.name || loading || (!error && result)}
                  className="w-full"
                >
                  추가
                </Button>
              </div>
              <Button
                type="primary"
                size="sm"
                onClick={handleUpload}
                disabled={!list.length || loading || (!error && result)}
              >
                업로드
              </Button>
            </div>
          )}
          {!loading && !error && result && (
            <SuccessAlert>{message}</SuccessAlert>
          )}
          {loading && (
            <progress className="w-full progress progress-primary"></progress>
          )}
          {error && <ErrorAlert>{message}</ErrorAlert>}
        </div>
        <div className="justify-center card-actions">
          <Button
            className="w-full text-black border-0 bg-zinc-300 hover:bg-zinc-400"
            onClick={handleClose}
          >
            <Icon name="x" size="sm" className="inline-block" />
            닫기
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadModal;
